import { StateService } from "@uirouter/angularjs";
import angular, { Injectable, IQService } from "angular";
import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
} from "../../../../records/forms/formView";
import { ColumnDefinitionService } from "../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../records/grids/controller";
import {
  GridConfiguration,
  RecordGridViewService,
} from "../../../../records/views/recordGridView";

export const vsServiceName = "lookupManagementService";

export interface LookupManagementConfigFactory {
  (...args: any[]): LookupManagementConfig;
}

export interface LookupManagementConfig {
  fetchFormModel: (id: any) => any;
  displayName?: string;
}

export interface LookupEntry {
  displayName: string;
  config: Injectable<LookupManagementConfigFactory>;
}

export interface TypeDisplayInfo {
  name: string;
  displayName: string;
}

export interface LookupEntryCollection {
  [name: string]: LookupEntry;
}

export class LookupManagementService {
  constructor(
    private readonly lookupManagementConfigs: LookupEntryCollection,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly $q: IQService,
    private readonly $injector: angular.auto.IInjectorService
  ) {}

  getConfigs(): TypeDisplayInfo[] {
    return Object.entries(this.lookupManagementConfigs).map((entry) => {
      return {
        name: entry[0],
        displayName: entry[1].displayName,
      };
    });
  }

  getLookupConfig(name: string) {
    const entry = this.lookupManagementConfigs[name];
    const config = this.$injector.invoke(entry.config);
    config.displayName ??= entry.displayName;
    return config;
  }

  getFormConfiguration(name: string): FormViewConfig | undefined {
    const config = this.formViewService.getFormViewConfig(name);

    if (config === undefined) return undefined;

    const defaultSubmit = config.submitForm;
    config.submitForm = (args: FormSubmitArgs) =>
      defaultSubmit(args).then((result) => {
        this.$state.go("^.grid");
        return result;
      });

    return config;
  }

  getGridConfig(name: string): GridConfiguration | undefined {
    const gridConfiguration =
      this.recordGridViewService.getGridConfiguration(name);

    if (gridConfiguration === undefined) {
      return undefined;
    }

    gridConfiguration?.columns?.splice(
      0,
      0,
      this.columnDefinitionService.getCommandColDef({
        name: "edit",
        headerName: "edit",
        iconClass: "text-primary fa fa-pencil",
        width: 20,
        colId: "edit",
      })
    );
    gridConfiguration.onItemCommand = [
      "args",
      (args: IRowCommandEventArgs<any>) => {
        switch (args.commandName) {
          case "edit":
            return this.navigateToEdit(args.data.Id).then(() => {});
          default:
            return this.$q.when();
        }
      },
    ];

    return gridConfiguration;
  }

  private navigateToEdit(id: number) {
    return this.$state.go("^.edit", { id });
  }
}
